export const cityConstant = {
    FETCH_CITIES_REQUEST: "FETCH_CITIES_REQUEST",
    FETCH_CITIES_SUCCESS: "FETCH_CITIES_SUCCESS",
    FETCH_CITIES_FAIL: "FETCH_CITIES_FAIL",

    CLEAR_ERRORS: "CLEAR_ERRORS"
}